export default {
    chat: {
    // 標題
        title: '聊天',
        hiroTitle: 'Hiro',
        hiroSubtitle: '撰寫助手',
        taskProcessing: '任務處理中',
        planDefaultTitle: '執行計畫',
        planStepFallback: '步驟 {index}',
        planTypes: {
            Free: '免費版',
            Internal: '內部版',
            Pro: 'Pro',
            Enterprise: '企業版',
        },

        // 歡迎頁面
        welcome: {
            title: '你好！我是 Hiro',
        },
        hiroIntro: '你的智能專利撰寫助手，專注於幫助你高效完成專利申請文件的撰寫和審查。',
        disclaimer: 'AI生成僅供參考',
        readOnlyWarning: '權限不足：您只有唯讀權限',

        // 空狀態
        empty: {
            tryExamples: '快速開始 - 試試這些示例',
        },

        // 後端任務狀態
        taskStatus: {
            PENDING: '等待執行',
            STARTED: '執行中',
            SUCCESS: '執行成功',
            FAILURE: '執行失敗',
            RETRY: '重試中',
            REVOKED: '已取消',
            INTERRUPTED: '已中斷',
        },

        // 示例問題
        examples: [
            '幫我撰寫一份關於智能手機折疊屏技術的發明專利申請',
            '分析這份 OA 通知書中的審查意見',
            '優化權利要求書的撰寫，使其更加清晰和完整',
            '根據技術交底書生成說明書',
        ],

        // 輸入框
        input: {
            placeholder: {
                default: '輸入消息... 使用 {\'@\'} 添加引用',
                disabled: '輸入已禁用，請稍候...',
                sending: '正在發送消息...',
            },
            placeholderDisabled: '請等待 Hiro 完成當前任務...',
            placeholderWaiting: '等待回覆中...',
            send: '發送',
            stop: '停止執行',
            waiting: '處理中',
            selectedText: '已選擇文本',
            clearSelection: '清除選擇',
            disabledFooter: 'Hiro 正在處理，請稍候...',
            keys: {
                instruct: '指令',
                generate: '生成',
                edit: '編輯',
                upload: '上傳',
            },
            workMode: {
                agent: '智能體',
                copilot: '助手',
            },
            upgrade: '升級',
        },

        // 文件上傳
        upload: {
            filePromptSuffix: '閱讀這些文件，總結其中內容對當前任務的影響，生成下一步建議。',
        },

        // 對話歷史
        history: {
            title: '對話歷史',
            empty: '暫無對話歷史',
            search: '搜索對話',
            rename: '重命名',
            delete: '刪除',
            defaultTitle: '新對話',
            deleteConfirm: '確認刪除此對話嗎？',
            inputErrorMessage: '請輸入對話標題',
            renameSuccess: '重命名成功',
            // 日期分組標籤
            today: '今天',
            yesterday: '昨天',
            lastWeek: '最近一週',
            lastMonth: '最近一個月',
            older: '更早',
        },

        // 操作按鈕
        actions: {
            copy: '複製',
            copySuccess: '已複製到剪貼板',
            copyFailed: '複製失敗',
            mergeToDocument: '合併到文檔',
            mergeToDocumentTooltip: '將此內容合併寫入當前文檔',
            newChat: '新對話',
            selectLanguage: '設置AI輸出語言',
            languageLabel: '模型輸出語言',
            expandFullContent: '展開查看完整內容',
        },

        // 任務未完成提醒
        incompleteTasksDialog: {
            title: '任務尚未完成',
            description: '當前任務計劃中還有未完成的步驟：',
            bannerText: '任務已暫停，仍有未完成步驟',
            completedLabel: '已完成',
            incompleteLabel: '未完成',
            continueBtn: '繼續執行任務',
            endBtn: '結束任務',
            continueMessage: '請繼續執行剩餘的任務步驟',
            endMessage: '將所有任務計劃步驟標記為已完成，然後結束任務。',
            inputPlaceholder: '補充說明（可選）',
        },

        // 消息
        messages: {
            sendFailed: '發送消息失敗，請重試',
            connecting: '正在連接聊天...',
            applyingTemplate: '正在應用模板...',
            templateAppliedSuccess: '已成功應用模板：{name}',
            templateApplyFailed: '應用模板失敗，請重試',
            editorNotInitialized: '編輯器未初始化，無法應用模板',
            loadHistoryFailed: '載入對話歷史失敗',
            createFailed: '創建對話失敗',
            deleteFailed: '刪除對話失敗',
            renameFailed: '重命名對話失敗',
            permissionDenied: '您當前沒有使用 {agentName} 的權限，請聯繫銷售升級套餐。',
            permissionDeniedOverseas: '您當前沒有使用 {agentName} 的權限，請{upgradeLink}。',
            upgradePlan: '升級套餐',
            limitExceeded: '使用次數已達上限，請升級套餐或明天再試。',
            limitExceededOverseas: '使用次數已達上限，請{upgradeLink}或明天再試。',
            limitExceededGuest: '使用次數已達上限，請註冊帳號或明天再試。',
            taskInProgress: '您有另一個任務正在執行中，請等待執行完畢後再提交。',
            globalTaskLimitExceeded: '當前系統負載過高，請稍後再試。',
            interruptFailed: '中斷請求失敗，請重試',
        },

        // Agent 類型名稱
        agentTypes: {
            disclosure: '技術交底書',
            prosecution: '答覆審查意見',
            patent_draft: '專利撰寫',
        },

        // 指令相關
        instructions: {
            select: '選擇指令',
            refresh: '刷新指令列表',
            searchPlaceholder: '搜索指令...',
            noResults: '未找到相關指令',
            suggestionsTitle: '推薦指令',
            useThis: '使用此指令',
            navigate: '前往指令中心',
            instructionContent: '指令內容',
            description: '描述',
            tags: '標籤',
            jurisdiction: '適用地區',
            createdAt: '創建時間',
            exampleOutput: '示例輸出',
            close: '關閉',
        },

        // Pending 狀態
        pending: {
            title: '需要你的輸入',
            subtitle: 'Hiro 需要更多信息才能繼續',
            inputLabel: '你的回答',
            waitingInfo: '等待你的確認或輸入',
            tools: {
                askUser: '詢問用戶',
                task: '任務確認',
                todoWrite: '待辦事項',
            },
        },

        // 決策表單
        decisionForm: {
            multiSelectHint: '(可多選)',
            inputPlaceholder: '請輸入...',
            questionAdditionalPlaceholder: '如有補充說明，請在此輸入...',
            submitted: '已提交',
            submit: '提交',
            cancel: '取消',
            loading: '載入決策表單...',
            parseError: '⚠️ 決策表單數據格式錯誤',
        },

        // 任務建議
        suggestions: {
            title: '任務建議',
            agentLabels: {
                novelty: '專利查新智能體',
            },
        },

        // 引用內容
        reference: {
            label: '引用選中內容',
        },

        // 中斷提示
        interrupting: {
            title: '正在停止執行',
            description: '正在安全地終止當前任務...',
            interrupted_by_user: '執行已被用戶中斷',
            processing: '正在處理...',
        },

        // 錯誤信息
        error: {
            technicalDetails: '技術詳情（僅開發環境）',
            errorCode: '錯誤代碼：',
            permissionDeniedReadOnly: '當前為唯讀權限，無法發送消息',
            permissionDeniedEdit: '示例項目為唯讀，請{createLink}您自己的可編輯版本',
            createLink: '創建',
            permissionDeniedDelete: '當前權限不足，無法刪除',
            permissionDeniedNoAccess: '無權訪問此資源',
        },

        changesConfirmedContinue: '已完成文件修改確認，請繼續完成任務。',

        // 任務列表
        tasks: {
            completed: '已完成',
            markComplete: '標記為完成',
            collapse: '收起任務列表',
            expand: '展開查看全部任務',
        },

        // 工具相關
        toolCall: {
            result: '查看工具結果',
            toolResultLabel: '工具結果',
            toolResultHint: '此為工具執行的中間結果，最終內容請以「文檔」中的版本為準',
            parameterDetails: '參數詳情',
            executing: '執行中...',
            expand: '展開詳情',
            collapse: '收起',
        },

        // 圖片預覽
        imagePreview: {
            generatedImage: 'AI 生成圖片',
            zoomIn: '放大',
            zoomOut: '縮小',
            download: '下載',
            close: '關閉',
        },

        // 附圖生成
        imageGeneration: {
            title: '附圖生成分析',
            promptLabel: '生成提示詞',
            imagePreview: '生成結果',
            noImage: '暫無生成圖片',
        },

        // 工具名稱
        tools: {
            unknown: '工具調用',
            timeUnknown: '--:--',
            get_current_time: '獲取當前時間',
            create_document: '創建文檔',
            read_document: '讀取文檔',
            list_project_attachments: '列出項目附件',
            read_attachment_content: '讀取附件內容',
            read_image: '讀取圖片',
            auto_annotate_image: '自動標註圖片',
            intelligent_patent_search: '智能專利檢索',
            get_patent_details: '獲取專利詳情',
            web_search: '網絡搜索',
            patent_drafting_tool: '專利撰寫分析',
            patent_rule_review_tool: '專利規則審查',
            extract_oa_and_generate_rejection_table: '提取審查意見並生成駁回分析表',
            extract_oa_analysis: '提取審查意見並生成駁回分析表',
            extract_oa_info: '提取審查意見',
            extract_raw_text: '提取原文內容',
            generate_oa_strategy: '生成審查意見答覆策略',
            generate_oar_content: '生成OAR文檔',
            render_rejection_table: '展示駁回分析表',
            update_rejection_table: '更新駁回分析表',
            validate_oa_strategy: '驗證審查意見答覆策略',
            fetch_office_action_pdf: '獲取審查意見PDF',
            fetch_historical_files: '獲取歷史文件',
            analyze_disclosure: '分析技術交底書',
            novelty_creativity_evaluation: '新穎性創造性評估',
            update_plan: '更新計劃',
            read_style: '讀取撰寫風格',
            read_template: '讀取模板',
            request_user_decision: '請求用戶決策',
            load_skill: '加載技能',
            detect_and_setup_patent_office: '檢測並設置專利受理局',
            write_document: '撰寫文檔',
            express_generate_reply: '生成答覆意見',
            check_express_eligibility: '檢查生成條件',
            suggest_next_step: '建議下一步',
            analyze_oa_response_strategy: '分析審查意見答覆策略',
            streaming: '工具輸出中...',
            done: '工具調用已完成',
            generate_image: '附圖生成分析',
        },

        // 專利搜索結果渲染器
        patentSearch: {
            found: '前{count}篇相關專利',
            searchResult: '搜索結果',
            expand: '展開',
            collapse: '收起',
            applicationDate: '申請日期',
            publicationDate: '公開日期',
            relevance: '相關度',
            parseError: '數據解析失敗',
            showDetails: '專利詳情',
            noData: '暫無數據',
            searchTypes: {
                semantic_search: '語義檢索',
                structured_query: '結構化檢索',
                patent_number: '專利號檢索',
            },
        },

        // 浮動視窗
        floating: {
            minimize: '最小化',
            maximize: '最大化/還原',
            close: '關閉',
        },

        // 專利詳情渲染器
        patentDetail: {
            basicInfo: '基本信息',
            patentNumber: '專利號',
            title: '標題',
            applicationNumber: '申請號',
            applicationDate: '申請日期',
            publicationDate: '公開日期',
            inventor: '發明人',
            applicant: '申請人',
            abstract: '摘要',
            copySection: '複製章節',
            copyAll: '複製全部',
            export: '導出',
            copySuccess: '已複製 {section}',
            copyFailed: '複製失敗',
            exportSuccess: '導出成功',
            exportFailed: '導出失敗',
            images: '附圖',
            parseError: '數據解析失敗',
            fallbackHint: '以下為原始內容：',
            textFormatError: '當前內容為文字格式，請在對話中查看完整內容。',
        },

        // LLM 回放
        llmReplay: {
            title: '請求體',
            formView: '表單視圖',
            jsonView: 'JSON視圖',
            basicConfig: '基礎配置',
            model: '模型',
            modelPlaceholder: '例如: claude-4.5-sonnet',
            temperature: '溫度',
            maxTokens: '最大Token數',
            stream: '串流輸出',
            reasoningEffort: '推理強度',
            selectPlaceholder: '請選擇',
            messageList: '訊息列表',
            addMessage: '新增訊息',
            messageIndex: '訊息 {index}',
            delete: '刪除',
            role: '角色',
            rolePlaceholder: '請選擇角色',
            content: '內容',
            contentPlaceholder: '請輸入訊息內容',
            jsonPlaceholder: '請輸入JSON格式的請求體',
            jsonError: 'JSON格式錯誤: {message}',
            switchError: '無法切換: JSON格式錯誤',
            replayResult: '回放結果',
            fieldRole: '角色',
            fieldContent: '內容',
            finishReason: '完成原因',
            tokenUsage: 'Token 使用統計',
            promptTokens: '輸入 Tokens:',
            completionTokens: '輸出 Tokens:',
            totalTokens: '總計:',
            modelInfo: '模型資訊',
            modelLabel: '模型:',
            createdAt: '建立時間:',
            requestId: '請求 ID:',
            statusIdle: '未開始',
            statusReplaying: '回放中',
            statusSuccess: '成功',
            statusError: '失敗',
        },
    },
};
